import React, { useState, Fragment } from "react";
import TodoList from "./TodoList/TodoList";
import { TabView, TabPanel } from 'primereact/tabview';
import Extensiones from "./Extensiones/Extensiones";
import './Extensiones/ExtensionesStyles.scss'
import './TodoList/ToDoListStyles.scss'



const HomeScreen = () => {

    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <div style={{ height: '100%' }}>
            <div style={{ backgroundImage: `url("https://were.ppf.com.hn/web/Fondo.jpg")`, bottom: 0, backgroundSize: 'cover', backgroundPosition: 'center', overflow: 'hiddden', height: '100%', width: '100%' }}
                className="contenedor-imagen animate__animated animate__fadeIn animate__faster ">

                <TabView className="col-12 homeTabView" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel header="Tareas">
                        <TodoList />
                    </TabPanel>
                    {/* <TabPanel header="Calendario">
                        <SchedulerHomeScreen />
                    </TabPanel> */}
                    <TabPanel header="Extensiones">
                        <div className="homeTabView_Extenciones">
                        <Extensiones />
                        </div>
                    </TabPanel>
                </TabView>

            </div>
        </div>

    )
}

export default HomeScreen;